// eslint-disable-next-line import/no-named-as-default
import KnowledgeCenter from './KnowledgeCenter';

export * from './KnowledgeCenter';

export default KnowledgeCenter;
